import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Button,
    Box,
    Typography,
    BottomNavigation,
    BottomNavigationAction,
    useMediaQuery,
    useTheme,
    Zoom,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import BuildIcon from '@mui/icons-material/Build';
import WorkIcon from '@mui/icons-material/Work';
import ContactsIcon from '@mui/icons-material/Contacts';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.png';
import '../styles/Navbar.scss';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [value, setValue] = useState(0);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [showMobileNav, setShowMobileNav] = useState(true);
    const location = useLocation();
    const { isAuthenticated } = useAuth();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            
            // Desktop navbar átlátszóság kezelése
            const isScrolled = currentScrollY > 20;
            if (isScrolled !== scrolled) {
                setScrolled(isScrolled);
            }

            // Mobil navbar elrejtése/megjelenítése görgetéskor
            if (isMobile) {
                if (currentScrollY < lastScrollY || currentScrollY < 50) {
                    setShowMobileNav(true);
                } else if (currentScrollY > lastScrollY && currentScrollY > 50) {
                    setShowMobileNav(false);
                }
                setLastScrollY(currentScrollY);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [scrolled, lastScrollY, isMobile]);

    useEffect(() => {
        const currentPath = location.pathname;
        const index = navItems.findIndex(item => item.path === currentPath);
        if (index !== -1) {
            setValue(index);
        }
    }, [location]);

    const navItems = [
        { path: '/', label: 'Főoldal', icon: <HomeIcon /> },
        { path: '/rolunk', label: 'Rólunk', icon: <InfoIcon /> },
        { path: '/szolgaltatasok', label: 'Szolgáltatások', icon: <BuildIcon /> },
        { path: '/projektek', label: 'Projektek', icon: <WorkIcon /> },
        { path: '/kapcsolat', label: 'Kapcsolat', icon: <ContactsIcon /> },
    ];

    if (isAuthenticated) {
        navItems.push({
            path: '/admin',
            label: 'Admin',
            icon: <AdminPanelSettingsIcon />
        });
    }

    const renderDesktopNav = () => (
        <AppBar position="fixed" className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <Toolbar>
                <Link to="/" className="logo-container">
                    <img src={logo} alt="Toronyszerver KFT" className="logo-image" />
                    <Typography variant="h6" className="company-name">
                        Toronyszerver KFT
                    </Typography>
                </Link>
                <Box className="nav-links">
                    {navItems.map((item) => (
                        <Button
                            component={Link}
                            to={item.path}
                            key={item.path}
                            className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                        >
                            {item.label}
                        </Button>
                    ))}
                </Box>
            </Toolbar>
        </AppBar>
    );

    const renderMobileNav = () => (
        <Zoom in={showMobileNav}>
            <AppBar position="fixed" className="mobile-navbar" color="transparent" elevation={0}>
                <BottomNavigation
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    className="bottom-nav"
                >
                    {navItems.map((item, index) => (
                        <BottomNavigationAction
                            key={item.path}
                            component={Link}
                            to={item.path}
                            label={item.label}
                            icon={
                                <div className={`nav-icon-wrapper ${location.pathname === item.path ? 'active' : ''}`}>
                                    {item.icon}
                                </div>
                            }
                            className={location.pathname === item.path ? 'active' : ''}
                        />
                    ))}
                </BottomNavigation>
            </AppBar>
        </Zoom>
    );

    return isMobile ? renderMobileNav() : renderDesktopNav();
};

export default Navbar; 